import { LineBlockSingle } from './line-block-single'
import { LineBlockSplit } from './line-block-split'

export const LineBlockChart = function ({
  dataKey,
  chartData,
  tableData,
  strata,
  legendToggles,
  showTableToggle,
  showTable,
  tableDefinition,
  filterDefinition,
  onLegendToggle,
  onSplitFilterChange,
  splitChart = false,
  exporting = false,
  ...props
}) {
  const hasData = chartData?.length && tableData?.length
  if (!hasData) {
    return null
  }

  return splitChart
    ? (
      <LineBlockSplit
        dataKey={dataKey}
        chartData={chartData}
        tableData={tableData}
        showTableToggle={showTableToggle}
        showTable={showTable}
        tableProps={tableDefinition.props}
        legendToggles={legendToggles}
        onLegendToggle={onLegendToggle}
        // Split specific props
        strata={strata}
        filterDefinition={filterDefinition}
        onSplitFilterChange={onSplitFilterChange}
        displayOnly={exporting}
        {...props}
      />
    )
    : (
      <LineBlockSingle
        dataKey={dataKey}
        chartData={chartData[0]}
        tableData={tableData[0]}
        showTableToggle={showTableToggle}
        showTable={showTable}
        tableProps={tableDefinition.props}
        legendToggles={legendToggles}
        onLegendToggle={onLegendToggle}
        {...props}
      />
    )
}
